import { render, staticRenderFns } from "./developing.vue?vue&type=template&id=bd95abea&scoped=true&"
import script from "./developing.vue?vue&type=script&lang=js&"
export * from "./developing.vue?vue&type=script&lang=js&"
import style0 from "./developing.vue?vue&type=style&index=0&id=bd95abea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd95abea",
  null
  
)

export default component.exports